import React from 'react';
export const TextField = ({ label, placeholder, value, handleChange, errorMessage, }) => {
    let componentId;
    if (globalThis.crypto && globalThis.crypto.randomUUID) {
        componentId = globalThis.crypto.randomUUID();
    }
    else {
        componentId =
            Date.now().toString(16).slice(2) + Math.random().toString(16).slice(2);
    }
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { htmlFor: componentId, className: "text-dark-gray font-bold text-sm" }, label)),
        React.createElement("div", null,
            React.createElement("input", { id: componentId, type: "text", placeholder: placeholder, className: "w-full md:w-80 py-2 px-4 border border-light-blue-bg rounded-sm placeholder:font-normal placeholder:text-sm placeholder:text-vital-gray-default-300", value: value, onChange: e => handleChange(e.target.value) })),
        errorMessage && (React.createElement("div", { "data-for": "first-name-input", className: "mt-2 text-red text-sm" }, errorMessage))));
};
